<script lang="ts">
	/** Total frame height for the plot area (axes included). */
	export let height = 220;
	export let variant: 'cartesian' | 'pie' = 'cartesian';
	/** Reserve space below the plot for a built-in DS legend. */
	export let reserveLegendSlot = true;
	$: hideBuiltInLegend = !reserveLegendSlot;
</script>

<div
	class="em-chart-frame"
	class:em-chart-frame-pie={variant === 'pie'}
	class:em-chart-frame-no-legend={hideBuiltInLegend}
	style={`--em-chart-height: ${height}px;`}
>
	<slot />
</div>

<style lang="scss">
	.em-chart-frame {
		position: relative;
		width: 100%;
		min-width: 0;
		height: var(--em-chart-height);
		box-sizing: border-box;
	}

	.em-chart-frame-pie {
		height: auto;
		min-height: var(--em-chart-height);
	}

	.em-chart-frame:not(.em-chart-frame-pie) :global(.layer-chart-theme) {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
	}

	.em-chart-frame:not(.em-chart-frame-pie) :global(.layer-chart-spacing) {
		height: 100%;
		min-height: 0;
	}

	.em-chart-frame:not(.em-chart-frame-pie) :global(.layer-chart-theme .lc-area-chart) {
		display: flex;
		flex-direction: column;
		height: 100%;
		min-height: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.em-chart-frame:not(.em-chart-frame-pie) :global(.layer-chart-theme .lc-area-chart .h-full),
	.em-chart-frame:not(.em-chart-frame-pie)
		:global(.layer-chart-theme .lc-area-chart .layercake-container),
	.em-chart-frame:not(.em-chart-frame-pie) :global(.layer-chart-theme .lc-area-chart .TooltipContext) {
		flex: 1 1 auto;
		min-height: 0;
		height: 100%;
		width: 100%;
	}

	.em-chart-frame:not(.em-chart-frame-pie) :global(.layer-chart-theme .lc-legend) {
		flex: 0 0 auto;
		margin: 8px 12px 0;
		padding: 0 8px 4px;
		gap: 14px;
		justify-content: center;
	}

	.em-chart-frame:not(.em-chart-frame-pie) :global(.layer-chart-theme .lc-legend .lc-legend-item) {
		display: inline-flex;
		align-items: center;
		gap: 6px;
	}

	.em-chart-frame-pie :global(.layer-chart-theme.lc-pie-chart) {
		display: flex;
		flex-direction: column;
		min-height: var(--em-chart-height);
		padding: 0;
		overflow: visible;
	}

	.em-chart-frame-pie :global(.layer-chart-theme.lc-pie-chart .layercake-container) {
		flex: 1 1 auto;
		min-height: 0;
		height: 100%;
	}

	.em-chart-frame-pie :global(.layer-chart-theme .lc-pie-slice-label) {
		display: none !important;
	}

	.em-chart-frame-no-legend :global(.layer-chart-theme .lc-legend) {
		display: none !important;
	}

	.em-chart-frame-no-legend:not(.em-chart-frame-pie) :global(.layer-chart-theme .lc-area-chart) {
		padding-bottom: 0;
	}

	.em-chart-frame :global(.layer-chart-theme.lc-dual-axis) {
		width: 100%;
	}

	.em-chart-frame :global(.lc-axis-left-tick-label),
	.em-chart-frame :global(.lc-axis-bottom-tick-label),
	.em-chart-frame :global(.lc-axis-right-tick-label) {
		font-size: 10px;
		fill: var(--color-muted);
	}
</style>
